var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "brick-base",
    { staticClass: "brick-octagon" },
    [
      _c(
        "svg",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            width: "97",
            height: "97",
            viewBox: "0 0 97 97"
          }
        },
        [
          _c("defs", [
            _c(
              "filter",
              { attrs: { id: "shadow" } },
              [
                _c("feDropShadow", {
                  attrs: {
                    dx: "4.55",
                    dy: "4.55",
                    stdDeviation: "5",
                    "flood-color": "rgba(0,0,0, 0.74)"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "filter",
              {
                attrs: {
                  id: "Polygon_1",
                  x: "0",
                  y: "0",
                  width: "97",
                  height: "97",
                  filterUnits: "userSpaceOnUse"
                }
              },
              [
                _c("feDropShadow", {
                  attrs: {
                    dx: "0",
                    dy: "0",
                    stdDeviation: "0.5",
                    "flood-color": "cyan"
                  }
                }),
                _vm._v(" "),
                _c("feOffset", { attrs: { input: "SourceAlpha" } }),
                _vm._v(" "),
                _c("feGaussianBlur", {
                  attrs: { stdDeviation: "1", result: "blur" }
                }),
                _vm._v(" "),
                _c("feComposite", { attrs: { in: "SourceGraphic" } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "filter",
              {
                attrs: {
                  id: "map-signs-solid",
                  x: "21.5",
                  y: "24.5",
                  width: "54",
                  height: "54",
                  filterUnits: "userSpaceOnUse"
                }
              },
              [
                _c("feOffset", { attrs: { input: "SourceAlpha" } }),
                _vm._v(" "),
                _c("feGaussianBlur", {
                  attrs: { stdDeviation: "0.5", result: "blur-2" }
                }),
                _vm._v(" "),
                _c("feFlood", { attrs: { "flood-opacity": "0.161" } }),
                _vm._v(" "),
                _c("feComposite", { attrs: { operator: "in", in2: "blur-2" } }),
                _vm._v(" "),
                _c("feComposite", { attrs: { in: "SourceGraphic" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "g",
            {
              attrs: {
                id: "octagon_divider",
                "data-name": "octagon divider",
                transform: "translate(3 3)"
              }
            },
            [
              _c(
                "g",
                {
                  staticClass: "cls-7",
                  attrs: { transform: "matrix(1, 0, 0, 1, -3, -3)" }
                },
                [
                  _c(
                    "g",
                    {
                      staticClass: "cls-1",
                      attrs: {
                        id: "Polygon_1-2",
                        "data-name": "Polygon 1",
                        transform: "translate(3 3)"
                      }
                    },
                    [
                      _c("path", {
                        staticClass: "cls-3 background",
                        attrs: {
                          d:
                            "M 61.86142349243164 90.5 L 29.13856506347656 90.5 C 27.66945838928223 90.5 26.28828239440918 89.92789459228516 25.24946975708008 88.88908386230469 L 2.110917568206787 65.75051879882813 C 1.072105884552002 64.71170806884766 0.5 63.33052825927734 0.5 61.86142349243164 L 0.5000117421150208 29.13855361938477 C 0.5000117421150208 27.66945838928223 1.072117686271667 26.28828239440918 2.110929489135742 25.24946975708008 L 25.2494945526123 2.110917568206787 C 26.28830528259277 1.072105884552002 27.66948318481445 0.5 29.13857650756836 0.5 L 61.86142349243164 0.5000117421150208 C 63.33052825927734 0.5000117421150208 64.71169281005859 1.072105884552002 65.75051879882813 2.110917568206787 L 88.88909149169922 25.24948310852051 C 89.92790222167969 26.28830528259277 90.5 27.66948318481445 90.49998474121094 29.13857650756836 L 90.49998474121094 61.86143493652344 C 90.49998474121094 63.33053970336914 89.92789459228516 64.71170806884766 88.88908386230469 65.75052642822266 L 65.75051879882813 88.88908386230469 C 64.71170806884766 89.92789459228516 63.33052825927734 90.5 61.86142349243164 90.5 Z"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "cls-4",
                        attrs: {
                          d:
                            "M 29.13857650756836 1 C 27.80302429199219 1 26.54740905761719 1.520088195800781 25.60305023193359 2.4644775390625 L 2.4644775390625 25.60303497314453 C 1.520088195800781 26.54740905761719 1 27.80301284790039 1 29.1385612487793 L 1 61.86142730712891 C 1 63.19697570800781 1.520088195800781 64.45259094238281 2.464462280273438 65.39694976806641 L 25.60303497314453 88.53553771972656 C 26.54740142822266 89.47991180419922 27.80301284790039 90 29.1385612487793 90 L 61.86142730712891 90 C 63.19697570800781 90 64.45259094238281 89.47991180419922 65.39694976806641 88.5355224609375 L 88.5355224609375 65.39696502685547 C 89.47989654541016 64.45259857177734 89.99998474121094 63.19698715209961 89.99998474121094 61.86143493652344 L 89.99998474121094 29.1385612487793 C 90 27.80302429199219 89.47991180419922 26.54740905761719 88.5355224609375 25.60303497314453 L 65.39694976806641 2.4644775390625 C 64.45257568359375 1.520088195800781 63.19697570800781 1 61.86142730712891 1 L 29.13857650756836 1 M 29.13857650756836 0 L 61.86142730712891 0 C 63.45272445678711 0 64.97885131835938 0.6321487426757813 66.10406494140625 1.757362365722656 L 89.24263763427734 24.89592742919922 C 90.36785888671875 26.02114868164063 91 27.54727554321289 90.99998474121094 29.13857650756836 L 90.99998474121094 61.86143493652344 C 90.99998474121094 63.45273590087891 90.36785125732422 64.97886657714844 89.24263763427734 66.10407257080078 L 66.10406494140625 89.24263763427734 C 64.97885131835938 90.36785888671875 63.45272445678711 91 61.86142730712891 91 L 29.1385612487793 91 C 27.54726409912109 91 26.02114105224609 90.36785888671875 24.89592742919922 89.24263763427734 L 1.757347106933594 66.10406494140625 C 0.63214111328125 64.97885131835938 0 63.45272445678711 0 61.86142730712891 L 0 29.1385612487793 C 0 27.54726409912109 0.6321487426757813 26.02114105224609 1.757362365722656 24.89592742919922 L 24.89593505859375 1.757362365722656 C 26.02114868164063 0.63214111328125 27.54727554321289 0 29.13857650756836 0 Z"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "g",
                {
                  staticClass: "cls-6",
                  attrs: { transform: "matrix(1, 0, 0, 1, -3, -3)" }
                },
                [
                  _c(
                    "g",
                    {
                      staticClass: "cls-2",
                      attrs: {
                        id: "map-signs-solid-2",
                        "data-name": "map-signs-solid",
                        transform: "translate(23 26)"
                      }
                    },
                    [
                      _c("path", {
                        staticClass: "cls-3",
                        attrs: {
                          d:
                            "M 27.09600067138672 50.75 L 23.90850067138672 50.75 C 23.16755104064941 50.75 22.56475067138672 50.14720153808594 22.56475067138672 49.40625 L 22.56475067138672 38.5 L 28.43975067138672 38.5 L 28.43975067138672 49.40625 C 28.43975067138672 50.14720153808594 27.83695030212402 50.75 27.09600067138672 50.75 Z M 45.42412948608398 34.8125 L 7.037660598754883 34.8125 C 6.25269079208374 34.8125 5.514930725097656 34.50703811645508 4.960280895233154 33.9523811340332 L 0.6462006568908691 29.6382999420166 C 0.1222006678581238 29.11429977416992 0.1222006678581238 28.26169967651367 0.6462006568908691 27.73769950866699 L 4.960300445556641 23.42259979248047 C 5.515800476074219 22.86800956726074 6.253610610961914 22.5625 7.037660598754883 22.5625 L 22.31475067138672 22.5625 L 22.56475067138672 22.5625 L 22.56475067138672 22.3125 L 22.56475067138672 19.375 L 28.43975067138672 19.375 L 28.43975067138672 22.3125 L 28.43975067138672 22.5625 L 28.68975067138672 22.5625 L 45.42412948608398 22.5625 C 46.60446929931641 22.5625 47.56475067138672 23.52277946472168 47.56475067138672 24.7031307220459 L 47.56475067138672 32.67187881469727 C 47.56475067138672 33.85221862792969 46.60446929931641 34.8125 45.42412948608398 34.8125 Z M 43.96683883666992 15.6875 L 5.580380439758301 15.6875 C 4.400030612945557 15.6875 3.439750671386719 14.727219581604 3.439750671386719 13.54687976837158 L 3.439750671386719 5.578129768371582 C 3.439750671386719 4.397779941558838 4.400030612945557 3.4375 5.580380439758301 3.4375 L 22.31475067138672 3.4375 L 22.56475067138672 3.4375 L 22.56475067138672 3.1875 L 22.56475067138672 1.59375 C 22.56475067138672 0.8528000116348267 23.16755104064941 0.25 23.90850067138672 0.25 L 27.09600067138672 0.25 C 27.83695030212402 0.25 28.43975067138672 0.8528000116348267 28.43975067138672 1.59375 L 28.43975067138672 3.1875 L 28.43975067138672 3.4375 L 28.68975067138672 3.4375 L 43.96683883666992 3.4375 C 44.75180053710938 3.4375 45.48955917358398 3.742959976196289 46.04421997070313 4.297619819641113 L 50.35828018188477 8.612680435180664 C 50.88188171386719 9.136280059814453 50.88182067871094 9.988949775695801 50.35816192626953 10.51344966888428 L 46.04421997070313 14.82738018035889 C 45.48870086669922 15.38199043273926 44.75088882446289 15.6875 43.96683883666992 15.6875 Z"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "cls-5",
                        attrs: {
                          d:
                            "M 23.90850067138672 0.5 C 23.30540084838867 0.5 22.81475067138672 0.9906501770019531 22.81475067138672 1.59375 L 22.81475067138672 3.1875 L 22.81475067138672 3.6875 L 22.31475067138672 3.6875 L 5.580371856689453 3.6875 C 4.537879943847656 3.6875 3.689750671386719 4.535629272460938 3.689750671386719 5.578121185302734 L 3.689750671386719 13.54687118530273 C 3.689750671386719 14.58937072753906 4.537879943847656 15.4375 5.580371856689453 15.4375 L 43.96684265136719 15.4375 C 44.68418884277344 15.4375 45.35927200317383 15.15793991088867 45.86745071411133 14.65061187744141 L 50.18124008178711 10.33681106567383 C 50.60758209228516 9.9097900390625 50.60771179199219 9.215660095214844 50.18149185180664 8.7894287109375 L 45.86745071411133 4.474388122558594 C 45.36001205444336 3.966960906982422 44.68503189086914 3.6875 43.96684265136719 3.6875 L 28.68975067138672 3.6875 L 28.18975067138672 3.6875 L 28.18975067138672 3.1875 L 28.18975067138672 1.59375 C 28.18975067138672 0.9906501770019531 27.69910049438477 0.5 27.09600067138672 0.5 L 23.90850067138672 0.5 M 22.81475067138672 19.625 L 22.81475067138672 22.3125 L 22.81475067138672 22.8125 L 22.31475067138672 22.8125 L 7.037662506103516 22.8125 C 6.3203125 22.8125 5.645229339599609 23.09206008911133 5.137088775634766 23.59934997558594 L 0.8229713439941406 27.91447067260742 C 0.3964500427246094 28.34099960327148 0.3964500427246094 29.03499984741211 0.8229713439941406 29.4615306854248 L 5.137050628662109 33.77561187744141 C 5.644489288330078 34.28303909301758 6.319469451904297 34.5625 7.037662506103516 34.5625 L 45.42412185668945 34.5625 C 46.46662139892578 34.5625 47.31475067138672 33.71437072753906 47.31475067138672 32.67186737060547 L 47.31475067138672 24.7031192779541 C 47.31475067138672 23.66062927246094 46.46662139892578 22.8125 45.42412185668945 22.8125 L 28.68975067138672 22.8125 L 28.18975067138672 22.8125 L 28.18975067138672 22.3125 L 28.18975067138672 19.625 L 22.81475067138672 19.625 M 22.81475067138672 38.75 L 22.81475067138672 49.40625 C 22.81475067138672 50.00934982299805 23.30540084838867 50.5 23.90850067138672 50.5 L 27.09600067138672 50.5 C 27.69910049438477 50.5 28.18975067138672 50.00934982299805 28.18975067138672 49.40625 L 28.18975067138672 38.75 L 22.81475067138672 38.75 M 23.90850067138672 0 L 27.09600067138672 0 C 27.9765510559082 0 28.68975067138672 0.7131996154785156 28.68975067138672 1.59375 L 28.68975067138672 3.1875 L 43.96684265136719 3.1875 C 44.81251907348633 3.1875 45.62334060668945 3.523178100585938 46.22100067138672 4.120838165283203 L 50.53507995605469 8.435920715332031 C 51.15764236450195 9.058479309082031 51.15764236450195 10.06652069091797 50.53507995605469 10.69007873535156 L 46.22100067138672 15.0041618347168 C 45.62235260009766 15.60182189941406 44.81251907348633 15.9375 43.96684265136719 15.9375 L 5.580371856689453 15.9375 C 4.260551452636719 15.9375 3.189750671386719 14.86669921875 3.189750671386719 13.54687118530273 L 3.189750671386719 5.578121185302734 C 3.189750671386719 4.25830078125 4.260551452636719 3.1875 5.580371856689453 3.1875 L 22.31475067138672 3.1875 L 22.31475067138672 1.59375 C 22.31475067138672 0.7131996154785156 23.02795028686523 0 23.90850067138672 0 Z M 22.31475067138672 19.125 L 28.68975067138672 19.125 L 28.68975067138672 22.3125 L 45.42412185668945 22.3125 C 46.74394989013672 22.3125 47.81475067138672 23.38330078125 47.81475067138672 24.7031192779541 L 47.81475067138672 32.67186737060547 C 47.81475067138672 33.99169921875 46.74394989013672 35.0625 45.42412185668945 35.0625 L 7.037662506103516 35.0625 C 6.191982269287109 35.0625 5.381160736083984 34.72682189941406 4.783500671386719 34.12915802001953 L 0.46942138671875 29.8150806427002 C -0.1531410217285156 29.19252014160156 -0.1531410217285156 28.18347930908203 0.46942138671875 27.56092071533203 L 4.783500671386719 23.24584007263184 C 5.382152557373047 22.64818000793457 6.191982269287109 22.3125 7.037662506103516 22.3125 L 22.31475067138672 22.3125 L 22.31475067138672 19.125 Z M 22.31475067138672 38.25 L 28.68975067138672 38.25 L 28.68975067138672 49.40625 C 28.68975067138672 50.28680038452148 27.9765510559082 51 27.09600067138672 51 L 23.90850067138672 51 C 23.02795028686523 51 22.31475067138672 50.28680038452148 22.31475067138672 49.40625 L 22.31475067138672 38.25 Z"
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }